import { HttpResponse } from '@angular/common/http';
import { DataWithPagingMetadata } from './model';
import { parsePagingMetadata } from './parse';
import { DatePipe } from '@angular/common';

export function augmentPaging<T>(response: HttpResponse<T[]>) {
  const body: any = response.body;
  const data = (body && typeof body === 'object' && !Array.isArray(body) && 'value' in body) ? body.value : (body ?? []);
  return { data: data, paging: parsePagingMetadata(response.headers) } as DataWithPagingMetadata<T>;
}

export function augmentForKendo<T>(data: DataWithPagingMetadata<T>) {
  const list = Array.isArray(data?.data) ? data.data : ((data?.data as any)?.value ?? []);
  return { data: list, total: data?.paging?.total ?? list.length };
}

export function augmentForKendoExcel<T>(data: any) {
  data.data.value = data.data.value ?? data.data;

  if (data.data.value.length > 0) {
    const datePipe = new DatePipe('en-US');

    data.data.value.forEach((x: any) => {
      Object.keys(x).forEach((key) => {
        if (Object.prototype.toString.call(x[key]) == '[object String]' && x[key].length > 10 && !isNaN(Date.parse(x[key]))) {
          x[key] = datePipe.transform(x[key], 'MM-dd-yyyy');
        }
      });

      if (x['firstName'] && x['lastName']) {
        x['fullName'] = x['firstName'] + ' ' + x['lastName'];
      }
    });
  }

  return {
    data: data.data.value,
    total: data.paging.total,
  };
}
